class EventCalendar {
  constructor() {
    this.currentDate = new Date();
    this.events = [];
    this.isMobile = window.innerWidth < 749;
    this.viewMode = this.isMobile ? 'list' : 'calendar';
    
    // Fallback-Bild für Produkte ohne Bilder
    this.defaultProductImage = 'https://cdn.shopify.com/s/files/1/0670/7545/8152/files/event-placeholder.jpg?v=1686211975';
    
    // DOM-Elemente initialisieren
    this.calendar = null;
    this.listView = null;
    this.monthTitle = null;
    this.calendarContainer = null;
    
    // Window resize handler für responsive Verhalten
    window.addEventListener('resize', this.handleResize.bind(this));
    
    // Globale Instanz für Zugriff von außen bereitstellen
    window.eventCalendar = this;
    
    // Globale Funktionen für Monatsnavigation (für direkte onclick-Handler)
    window.prevMonth = function() {
      console.log('Vorheriger Monat Funktion aufgerufen');
      if (window.eventCalendar) {
        window.eventCalendar.prevMonth();
      } else {
        console.error('EventCalendar-Instanz nicht gefunden!');
      }
      return false;
    };
    
    window.nextMonth = function() {
      console.log('Nächster Monat Funktion aufgerufen');
      if (window.eventCalendar) {
        window.eventCalendar.nextMonth();
      } else {
        console.error('EventCalendar-Instanz nicht gefunden!');
      }
      return false;
    };
    
    this.init();
  }

  init() {
    this.loadEvents().then(() => {
      // Standardmäßig aktueller Monat
      this.currentDate = new Date();
      
      // Prüfen, ob im aktuellen Monat verfügbare Events sind
      const currentMonth = this.currentDate.getMonth();
      const currentYear = this.currentDate.getFullYear();
      
      const hasAvailableEventsInCurrentMonth = this.events.some(event => 
        event.date.getMonth() === currentMonth && 
        event.date.getFullYear() === currentYear && 
        event.available === true
      );
      
      // Wenn keine verfügbaren Events im aktuellen Monat, zum nächsten verfügbaren Event springen
      if (!hasAvailableEventsInCurrentMonth) {
        // Sortieren nach Datum und nur verfügbare Events berücksichtigen
        const futureAvailableEvents = this.events
          .filter(event => event.available === true && event.date >= new Date())
          .sort((a, b) => a.date - b.date);
        
        if (futureAvailableEvents.length > 0) {
          // Zum Monat des nächsten verfügbaren Events wechseln
          this.currentDate = new Date(futureAvailableEvents[0].date);
          console.log('Switching to next available event in month:', 
                    this.currentDate.getMonth() + 1, this.currentDate.getFullYear());
        }
      }
      
      // DOM-Elemente initialisieren
      this.calendarContainer = document.querySelector('.calendar-container');
      this.calendar = document.querySelector('.calendar tbody');
      this.listView = document.querySelector('.events-list-view');
      this.monthTitle = document.querySelector('.current-month');
      this.calendarWrapper = document.querySelector('.calendar-wrapper');
      
      // View-Toggle-Button entfernen
      const viewToggleContainer = document.querySelector('.view-toggle-container');
      if (viewToggleContainer) {
        viewToggleContainer.style.display = 'none';
      }
      
      this.setupCalendar();
      this.setupToggle();
      this.setupNavigation();
      this.setupSwipeNavigation();
      
      // Ansicht basierend auf Gerätegröße wählen
      this.viewMode = this.isMobile ? 'list' : 'calendar';
      this.render();
    });
  }

  async loadEvents() {
    try {
      console.log('Loading events...');
      // Shopify Collection URL für Events
      const response = await fetch('/collections/kurse-und-events/products.json');
      const data = await response.json();
      
      // Den ersten Eintrag Debuggen, um die Struktur zu verstehen
      if (data.products && data.products.length > 0) {
        console.log('Erstes Produkt:', data.products[0].title);
        console.log('Produkt-Struktur:', JSON.stringify(data.products[0]).substring(0, 500) + '...');
      }
      
      this.events = data.products.flatMap(product => {
        // Garantiertes Produktbild - entweder vom Produkt oder Fallback
        let imageUrl = this.defaultProductImage; // Unser vordefiniertes Fallback-Bild
        
        // Prioritätsreihenfolge für das Bild
        if (product.images && product.images.length > 0 && product.images[0].src) {
          // Option 1: Die erste URL aus dem product.images Array verwenden (prioritär)
          imageUrl = product.images[0].src;
          console.log('✅ Bild aus product.images[0].src geladen:', product.title);
        } else if (product.featured_image) {
          // Option 2: featured_image direkt verwenden wenn vorhanden
          imageUrl = product.featured_image;
          console.log('✅ Bild aus featured_image geladen:', product.title);
        } else {
          // Fallback verwenden
          console.log('⚠️ Kein Bild gefunden, verwende Fallback für:', product.title);
        }
        
        return product.variants.map(variant => {
          const dateMatch = variant.title.match(/(\d{1,2})\.\ *([A-Za-zä]+)\ *(\d{4}),\ *(\d{1,2}):(\d{2})/);
          if (dateMatch) {
            const [_, day, month, year, hours, minutes] = dateMatch;
            const monthMap = {
              'Januar': 0, 'Jan': 0, 'Februar': 1, 'Feb': 1, 'März': 2, 'Mär': 2,
              'April': 3, 'Apr': 3, 'Mai': 4, 'Juni': 5, 'Jun': 5, 'Juli': 6, 'Jul': 6,
              'August': 7, 'Aug': 7, 'September': 8, 'Sep': 8, 'Oktober': 9, 'Okt': 9,
              'November': 10, 'Nov': 10, 'Dezember': 11, 'Dez': 11
            };
            
            // Monat in Nummer umwandeln (0-11)
            const monthNum = monthMap[month];
            
            // Wenn Monat ungültig, Konsole-Fehler und fortfahren
            if (monthNum === undefined) {
              console.error('Ungültiger Monat in Variant title:', month, 'für Produkt:', product.title);
              return null;
            }
            
            // Datum erstellen
            const date = new Date(parseInt(year), monthNum, parseInt(day), parseInt(hours), parseInt(minutes));
            
            // Event-Objekt erstellen
            return {
              id: variant.id,
              product_id: product.id,
              title: product.title,
              price: variant.price,
              available: variant.available,
              url: '/products/' + product.handle + '?variant=' + variant.id,
              imageUrl: imageUrl,
              date: date,
              location: product.title.includes('Culinary Center') ? 'Culinary Center Kirchheim' : '',
              variantTitle: variant.title
            };
          }
          return null;
        }).filter(Boolean); // Filtere null-Werte aus dem Array
      });
      
      console.log('Loaded events:', this.events.length);
      return this.events;
    } catch (error) {
      console.error('Error loading events:', error);
      return [];
    }
  }

  setupCalendar() {
    this.calendarContainer = document.querySelector('.calendar-container');
    this.calendar = document.querySelector('.calendar tbody');
    this.listView = document.querySelector('.events-list-view');
    this.monthTitle = document.querySelector('.current-month');
  }
  
  setupToggle() {
    const toggleButton = document.querySelector('.calendar-toggle-button');
    const toggleText = document.querySelector('.toggle-text');
    const calendarWrapper = document.querySelector('.calendar-wrapper');
    const calendarToggle = document.querySelector('.calendar-toggle');
    
    // Auf mobilen Geräten den Toggle-Button ausblenden
    if (this.isMobile && calendarToggle) {
      calendarToggle.style.display = 'none';
    }
    
    if (toggleButton && calendarWrapper) {
      toggleButton.addEventListener('click', () => {
        const isExpanded = calendarWrapper.classList.contains('expanded');
        
        if (isExpanded) {
          calendarWrapper.classList.remove('expanded');
          calendarWrapper.classList.add('collapsed');
          if (toggleText) toggleText.textContent = 'Kalender ausklappen';
        } else {
          calendarWrapper.classList.remove('collapsed');
          calendarWrapper.classList.add('expanded');
          if (toggleText) toggleText.textContent = 'Kalender einklappen';
        }
      });
    }
  }

  // Neue Methode für vorherigen Monat
  prevMonth() {
    console.log('EventCalendar.prevMonth() wurde aufgerufen');
    const newDate = new Date(this.currentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    this.currentDate = newDate;
    this.render();
    
    // Update alle Monatstitel (auch die in der mobilen Ansicht)
    const allMonthTitles = document.querySelectorAll('.current-month');
    allMonthTitles.forEach(title => {
      const monthName = this.currentDate.toLocaleDateString('de-DE', { month: 'long' });
      title.textContent = monthName + ' ' + this.currentDate.getFullYear();
    });
  }
  
  // Neue Methode für nächsten Monat
  nextMonth() {
    console.log('EventCalendar.nextMonth() wurde aufgerufen');
    const newDate = new Date(this.currentDate);
    newDate.setMonth(newDate.getMonth() + 1);
    this.currentDate = newDate;
    this.render();
    
    // Update alle Monatstitel (auch die in der mobilen Ansicht)
    const allMonthTitles = document.querySelectorAll('.current-month');
    allMonthTitles.forEach(title => {
      const monthName = this.currentDate.toLocaleDateString('de-DE', { month: 'long' });
      title.textContent = monthName + ' ' + this.currentDate.getFullYear();
    });
  }
  
  setupNavigation() {
    const allPrevButtons = document.querySelectorAll('.prev-month');
    const allNextButtons = document.querySelectorAll('.next-month');
    
    // Füge allen gefundenen Prev-Buttons einen Event-Listener hinzu
    allPrevButtons.forEach(button => {
      // Entferne mögliche alte Event-Listener
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      // Hinzufügen eines neuen Event-Listeners
      newButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.prevMonth();
        return false;
      });
    });
    
    // Füge allen gefundenen Next-Buttons einen Event-Listener hinzu
    allNextButtons.forEach(button => {
      // Entferne mögliche alte Event-Listener
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      // Hinzufügen eines neuen Event-Listeners
      newButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.nextMonth();
        return false;
      });
    });
    
    console.log('Navigation-Setup abgeschlossen mit ' + allPrevButtons.length + ' prev-Buttons und ' + allNextButtons.length + ' next-Buttons');
  }

  formatPrice(cents) {
    const euros = cents / 100;
    const formatter = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
    return formatter.format(euros);
  }

  formatTime(date) {
    return date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0');
  }
  
  // Behandelt die Größenänderung des Fensters für responsive Verhalten
  handleResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth < 749;
    
    // Wenn sich der mobile Status geändert hat, aktualisiere die Ansicht
    if (wasMobile !== this.isMobile) {
      this.viewMode = this.isMobile ? 'list' : 'calendar';
      
      // Kalender-Toggle-Button ein- oder ausblenden je nach Gerätegröße
      const calendarToggle = document.querySelector('.calendar-toggle');
      if (calendarToggle) {
        calendarToggle.style.display = this.isMobile ? 'none' : 'block';
      }
      
      this.render();
    }
  }
  
  // Diese Methoden wurden entfernt, da der Toggle zwischen Listenansicht und Kalenderansicht nicht mehr benötigt wird
  
  // Setup für Swipe-Gesten auf mobilen Geräten
  setupSwipeNavigation() {
    const calendarWrapper = document.querySelector('.calendar-wrapper');
    if (!calendarWrapper) return;
    
    let touchStartX = 0;
    let touchEndX = 0;
    
    calendarWrapper.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    calendarWrapper.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });
  }
  
  // Verarbeitet Swipe-Gesten für die Monatsnavigation
  handleSwipe(startX, endX) {
    const swipeThreshold = 50; // Mindestdistanz für einen Swipe
    
    if (startX - endX > swipeThreshold) {
      // Swipe nach links - nächster Monat
      const newDate = new Date(this.currentDate);
      newDate.setMonth(newDate.getMonth() + 1);
      this.currentDate = newDate;
      this.render();
    } else if (endX - startX > swipeThreshold) {
      // Swipe nach rechts - vorheriger Monat
      const newDate = new Date(this.currentDate);
      newDate.setMonth(newDate.getMonth() - 1);
      this.currentDate = newDate;
      this.render();
    }
  }
  
  // Hauptrender-Methode, die basierend auf der Ansicht entweder Kalender oder Liste rendert
  render() {
    if (this.viewMode === 'calendar') {
      this.renderCalendar();
      if (this.calendarContainer) this.calendarContainer.style.display = 'block';
      if (this.listView) this.listView.style.display = 'none';
    } else {
      this.renderListView();
      if (this.calendarContainer) this.calendarContainer.style.display = 'none';
      if (this.listView) this.listView.style.display = 'block';
    }
  }
  
  // Gibt HTML für alle Events an einem bestimmten Datum zurück
  getEventsForDate(date) {
    // Filtere Events für das angegebene Datum
    const eventsOnDate = this.events.filter(event => {
      return (
        event.date.getDate() === date.getDate() &&
        event.date.getMonth() === date.getMonth() &&
        event.date.getFullYear() === date.getFullYear()
      );
    });
    
    if (eventsOnDate.length === 0) return '';
    
    // Sortiere Events nach Uhrzeit
    eventsOnDate.sort((a, b) => a.date - b.date);
    
    // Generiere HTML für jedes Event
    return eventsOnDate.map(event => {
      // Wochentag und formatiertes Datum für dieses Event
      const weekday = event.date.toLocaleDateString('de-DE', { weekday: 'short' });
      const formattedDate = this.formatTime(event.date) + ' Uhr';
      
      // Event-Standort aus dem Datensatz extrahieren, falls vorhanden
      let location = '';
      if (event.location) {
        location = event.location;
      }
      
      // Die Bild-URL für dieses Event
      let imageUrl = event.imageUrl || this.defaultProductImage;
      
      // Bild-Container mit einheitlicher Höhe
      const imageHtml = `
        <div style="width: 100%; height: 200px; position: relative; overflow: hidden; display: flex; align-items: center; justify-content: center; background-color: #f8f8f8;">
          <img 
            src="${imageUrl}" 
            alt="${event.title}" 
            class="event-image" 
            style="width: 100%; height: 100%; object-fit: cover;" 
            onerror="this.src='${this.defaultProductImage}';"
          >
        </div>
      `;
      
      // AUSVERKAUFT-Label genau nach dem bereitgestellten Markup
      const soldOutBadge = !event.available ? 
        '<div style="margin-bottom: 1px; text-align: center;"><span style="display: inline-block; background-color: #c92400; color: white; font-size: 0.6rem; padding: 1px 5px; border-radius: 2px; transform: rotate(-5deg); font-weight: bold;">AUSVERKAUFT</span></div>' : '';
      
      // Vollständige HTML-Karte mit nur einem AUSVERKAUFT-Badge
      return `
        <div class="event" style="position: relative; margin-bottom: 10px;">
          <a href="${event.url}" style="text-decoration: none; color: inherit; display: block;">
            <div class="event-image-container" style="width: 100%; background-color: #f8f8f8; display: flex; justify-content: center; align-items: center; overflow: hidden;">
              ${imageHtml}
            </div>
            <div class="event-content" style="padding: 8px 0;">
              <div class="event-title" style="font-weight: 600; margin-bottom: 6px; font-size: 0.9em; color: #2c5738; line-height: 1.2;">
                <strong>${event.title}</strong>
              </div>
              
              <div class="event-info" style="margin-top: 4px; font-size: 0.65rem; color: #105742;">
                ${!event.available ? soldOutBadge : ''}
                <div class="event-date" style="display: flex; align-items: center; margin-bottom: 3px;">
                  <span style="margin-right: 3px;">
                    <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"></path>
                      <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"></path>
                    </svg>
                  </span>
                  <strong ${!event.available ? 'style="text-decoration: line-through; opacity: 0.7;"' : ''}>${weekday} - ${formattedDate}</strong>
                </div>
                
                ${location ? `
                <div class="event-location" style="display: flex; align-items: center;">
                  <span style="margin-right: 3px;">
                    <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"></path>
                    </svg>
                  </span>
                  ${location}
                </div>
                ` : ''}
              </div>
            </div>
          </a>
        </div>
      `;
    }).join('');
  }

  // Rendert die Listenansicht der Events
  renderListView() {
    if (!this.listView) return;
    
    // Aktualisiere den Monatstitel
    if (this.monthTitle) {
      const monthName = this.currentDate.toLocaleString('de-DE', { month: 'long' });
      const year = this.currentDate.getFullYear();
      this.monthTitle.textContent = `${monthName} ${year}`;
    }
    
    // Filtere Events für den aktuellen Monat
    const currentMonth = this.currentDate.getMonth();
    const currentYear = this.currentDate.getFullYear();
    const eventsThisMonth = this.events.filter(event => 
      event.date.getMonth() === currentMonth && 
      event.date.getFullYear() === currentYear
    ).sort((a, b) => a.date - b.date);
    
    // Generiere HTML für die Listenansicht
    let html = '';
    
    if (eventsThisMonth.length === 0) {
      html = '<div class="no-events">Keine Events in diesem Monat</div>';
    } else {
      eventsThisMonth.forEach(event => {
        const formattedDate = event.date.toLocaleDateString('de-DE', { 
          weekday: 'long', 
          day: '2-digit', 
          month: 'long', 
          year: 'numeric' 
        });
        
        const formattedTime = this.formatTime(event.date);
        
        const dateString = `${formattedDate}, ${formattedTime} Uhr`;
        
        // Event-Standort aus dem Datensatz extrahieren, falls vorhanden
        const location = event.location || '';
        
        // Bildcontainer mit Fallback
        const imageHtml = `
          <div class="event-image-container">
            <img 
              src="${event.imageUrl}" 
              alt="${event.title}" 
              class="event-image" 
              onerror="this.src='${this.defaultProductImage}';"
            >
          </div>
        `;
        
        // AUSVERKAUFT-Label
        const soldOutBadge = !event.available ? 
          '<div><span class="sold-out-badge" style="display: inline-block; background-color: #c92400; color: white; font-size: 0.7rem; padding: 2px 6px; border-radius: 2px; margin-right: 5px;">AUSVERKAUFT</span></div>' : '';
        
        html += `
          <div class="event-list-item">
            <a href="${event.url}">
              ${imageHtml}
              <div class="event-content">
                <div class="event-title">
                  ${event.title}
                </div>
                <div class="event-details">
                  <div class="event-time">
                    <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"></path>
                      <path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"></path>
                    </svg>
                    <span>${dateString}</span>
                  </div>
                  ${location ? `
                  <div class="event-location">
                    <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"></path>
                    </svg>
                    <span class="event-location-display">${location}</span>
                  </div>
                  ` : ''}
                </div>
               
              </div>
            </a>
          </div>
        `;
      });
    }
    
    this.listView.innerHTML = html;
  }
  
  renderCalendar() {
    // Aktualisiere den Monatstitel
    if (this.monthTitle) {
      const monthName = this.currentDate.toLocaleString('de-DE', { month: 'long' });
      const year = this.currentDate.getFullYear();
      this.monthTitle.textContent = `${monthName} ${year}`;
    }
    
    const month = this.currentDate.getMonth();
    const year = this.currentDate.getFullYear();
    
    // Erster Tag des Monats
    const firstDay = new Date(year, month, 1);
    
    // Letzter Tag des Monats
    const lastDay = new Date(year, month + 1, 0);
    
    // Tag der Woche für den ersten Tag (0 = Sonntag, 6 = Samstag)
    let firstDayOfWeek = firstDay.getDay();
    // In Europa beginnt die Woche mit Montag, daher Anpassung:
    firstDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
    
    // Anzahl der Tage im Monat
    const daysInMonth = lastDay.getDate();
    
    // Anzahl der Wochen, die angezeigt werden müssen
    const numWeeks = Math.ceil((daysInMonth + firstDayOfWeek) / 7);
    
    // HTML für den Kalender-Body generieren
    let html = '';
    
    // Startdatum für den Kalender (kann im vorherigen Monat liegen)
    const startDate = new Date(firstDay);
    startDate.setDate(startDate.getDate() - firstDayOfWeek);
    
    // Wochen generieren
    for (let i = 0; i < numWeeks; i++) {
      html += '<tr>';
      
      // Tage in der Woche generieren
      for (let j = 0; j < 7; j++) {
        const currentDate = new Date(startDate);
        const isCurrentMonth = currentDate.getMonth() === month;
        const isToday = currentDate.toDateString() === new Date().toDateString();
        
        // Zellenklasse basierend auf dem Monat
        const cellClass = isCurrentMonth ? '' : 'other-month';
        
        // HTML für die Zelle
        html += `
          <td class="${cellClass}" data-date="${currentDate.toISOString().split('T')[0]}">
            <div class="date">${currentDate.getDate()}</div>
            ${isCurrentMonth ? this.getEventsForDate(currentDate) : ''}
          </td>
        `;
        
        startDate.setDate(startDate.getDate() + 1);
      }
      html += '</tr>';
    }

    // Sicherstellen, dass this.calendar existiert, bevor wir innerHTML setzen
    if (this.calendar) {
      this.calendar.innerHTML = html;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new EventCalendar();
});